import ModalContainer from './modal-container'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type ACTION_TYPE = 'APPROVE' | 'DECLINE'

interface ConfirmationModalProps {
  show: boolean
  hasCloseButton?: boolean
  handleClose: () => void
  icon?: string | React.ReactNode
  iconClass?: string
  modalClass?: string
  title: string
  titleClass?: string
  actionBtnLoading?: boolean
  disableActionBtn?: boolean
  message: string | React.ReactNode
  messageClass?: string
  actionBtnTitle?: string | React.ReactNode
  handleClick?: () => void
  content?: React.ReactNode
  footerContent?: React.ReactNode
  actionType?: ACTION_TYPE
  actionBtnClass?: string
}

export default function ConfirmationModal({
  show,
  hasCloseButton = false,
  handleClose,
  icon,
  iconClass,
  actionBtnLoading,
  disableActionBtn,
  title,
  titleClass,
  message,
  messageClass,
  actionBtnTitle,
  handleClick,
  content,
  footerContent,
  modalClass,
  actionType,
  actionBtnClass,
}: ConfirmationModalProps) {
  return (
    <ModalContainer
      show={show}
      handleClose={handleClose}
      modalClass={cn(
        'w-full max-w-[calc(100vw-1.5rem)] rounded-3xl bg-white px-4 py-6 sm:max-w-lg sm:px-6 sm:py-10 md:w-[28.8rem] md:max-w-[30.8rem] lg:w-[28rem]',
        modalClass,
      )}
      hasCloseButton={hasCloseButton}
    >
      <section>
        <div className=''>
          <div className='text-center mb-5'>
            {icon && (
              <div className='flex justify-center'>
                {typeof icon === 'string' ? (
                  <img
                    src={icon}
                    width={71}
                    height={40}
                    className={`${cn(iconClass)}`}
                    alt={'icon'}
                  />
                ) : (
                  <div className={cn(iconClass)}>{icon}</div>
                )}
              </div>
            )}
            <h3
              className={cn(
                'mt-[14px] text-isGray900 font-bold leading-9 mx-auto',
                titleClass,
              )}
            >
              {title}
            </h3>
            <p
              className={cn(
                'mx-auto mt-3 w-full max-w-full px-1 text-left text-[13px] font-normal text-[#5B6871] sm:text-center sm:max-w-[307px]',
                messageClass,
              )}
            >
              {message}
            </p>
          </div>
          {content}
          {handleClick && (
            <div className='mt-8 flex w-full min-w-0 flex-col gap-3 lg:flex-row lg:flex-wr lg:justify-center'>
              <Button
                disabled={actionBtnLoading}
                className='h-11 w-full rounded-xl border px-6 font-normal lg:h-auto lg:w-fit lg:px-10 xl:px-16'
                onClick={handleClose}
                variant='ghost'
              >
                Cancel
              </Button>
              <Button
                loading={actionBtnLoading}
                disabled={disableActionBtn}
                className={cn(
                  'h-11 w-full rounded-xl px-6 font-normal lg:h-auto lg:w-fit lg:px-5 xl:px-10',
                  actionBtnClass,
                )}
                onClick={handleClick}
                variant={actionType === 'DECLINE' ? 'destructive' : 'default'}
              >
                {actionBtnTitle ? actionBtnTitle : 'Confirm'}
              </Button>
            </div>
          )}
          {footerContent && footerContent}
        </div>
      </section>
    </ModalContainer>
  )
}
